var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpriceRegisteredEsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 82.859 69.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.913,
    y1: 0.758,
    x2: 0.097,
    y2: 0.181,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1487ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78bc27"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25377",
    "data-name": "Group 25377",
    transform: "translate(-806 -524.883)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3860",
    "data-name": "Ellipse 3860",
    cx: 34.804,
    cy: 34.804,
    r: 34.804,
    transform: "translate(816.389 524.883)",
    fill: "#e7eff9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7611",
    "data-name": "Rectangle 7611",
    d: "M8.542,2.563a5.986,5.986,0,0,0-5.98,5.98V34.169a5.986,5.986,0,0,0,5.98,5.98H74.317a5.986,5.986,0,0,0,5.98-5.98V8.542a5.986,5.986,0,0,0-5.98-5.98H8.542M8.542,0H74.317a8.542,8.542,0,0,1,8.542,8.542V34.169a8.542,8.542,0,0,1-8.542,8.542H8.542A8.542,8.542,0,0,1,0,34.169V8.542A8.542,8.542,0,0,1,8.542,0Z",
    transform: "translate(806 538.332)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7612",
    "data-name": "Rectangle 7612",
    d: "M5.98,2.563A3.421,3.421,0,0,0,2.563,5.98v20.5A3.421,3.421,0,0,0,5.98,29.9H61.5a3.421,3.421,0,0,0,3.417-3.417V5.98A3.421,3.421,0,0,0,61.5,2.563H5.98M5.98,0H61.5a5.98,5.98,0,0,1,5.98,5.98v20.5a5.98,5.98,0,0,1-5.98,5.98H5.98A5.98,5.98,0,0,1,0,26.481V5.98A5.98,5.98,0,0,1,5.98,0Z",
    transform: "translate(811.125 543.459)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9294",
    "data-name": "Path 9294",
    d: "M1.708,0A1.708,1.708,0,1,1,0,1.708,1.708,1.708,0,0,1,1.708,0Z",
    transform: "translate(880.316 543.459)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpriceRegisteredEsl);
export default __webpack_public_path__ + "static/media/eprice_registered_esl.6586984ead578a3cd9a89dfb1215b5ce.svg";
export { ForwardRef as ReactComponent };